/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class VehicleEquipmentVo extends JSONable {
  uuid: string | null = null
  equipmentType: string | null = null
  installationDate: string | null = null
  uninstallationDate: string | null = null
  validFrom: string | null = null
  validTo: string | null = null
}
